import Bookmark from "components/features/library/Bookmark";
import LibaryHall from "components/features/library/libraryHall";
import Suggested from "./Suggested";
import AllPlans from "./allPlans";

export const libraryTabDetails = [
  {
    label: "Library Hall",
    content: LibaryHall
  },
  {
    label: "All Plans ",
    content: AllPlans
  },
  {
    label: "Bookmarked",
    content: Bookmark
  },
  {
    label: "Suggested",
    content: Suggested
  }
];

export const adminTabDetails = [
  {
    label: "Library Hall",
    content: LibaryHall
  },
  {
    label: "All Plans ",
    content: AllPlans
  },
  {
    label: "Bookmarked",
    content: Bookmark
  }
];
